import lodash from "lodash";
/**
 * This function iterates over the old and new key object and assigns the ui options of all children to the newly duplicated object
 * @param oldNewKeys
 * @param uiOptionsNew
 * @param oldUiSubSchemaItem
 * @param newKeyPathParent
 * @returns {object}  returns new uischema object with all ui options
 */
export const getDuplicateUiSchemaValues = (
  oldNewKeys: any[],
  uiOptionsNew: any,
  oldUiSubSchemaItem: string,
  newKeyPathParent: string
) => {
  oldNewKeys.forEach((keyPair) => {
    const fetchOldKeyUiOptions = lodash.get(oldUiSubSchemaItem, keyPair.oldKey);
    lodash.set(uiOptionsNew, `${newKeyPathParent}.${keyPair.newKey}`, {
      ...fetchOldKeyUiOptions,
    });
  });
  const fetchNewItemUiOptions = oldUiSubSchemaItem[`ui:options`];
  const findItem = lodash.get(uiOptionsNew, newKeyPathParent);
  lodash.set(uiOptionsNew, `${newKeyPathParent}`, {
    "ui:options": { ...fetchNewItemUiOptions },
    ...findItem,
  });
  return uiOptionsNew;
};
